import { derived } from 'svelte/store';
import _ from 'lodash';
import {v4 as uuidv4} from 'uuid';

import currentMonth from '../../methods/currentMonth';

import ExpenseStore from '../expenseStore';

let MonthsList = derived(ExpenseStore, ($ExpenseStore) => {
    let list = [];
    let orderedMonths = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];

    if (_.has($ExpenseStore, 'history')) {
        if (_.has($ExpenseStore.history, 'yearsList')) {
            const years = _.reverse($ExpenseStore.history.yearsList);

            // console.log($ExpenseStore.history);
            
            years.forEach(item => {
                let year = item;
                let activeYear;
                const currentYear = new Date().getFullYear();
                if (currentYear == item) {
                    activeYear = true;
                } else {
                    activeYear = false;
                }

                orderedMonths.forEach(item => {
                    if (_.has($ExpenseStore.history[year].monthsList, item)) {
                        let active;
                        const currentMonth = new Date().getMonth();
                        if (orderedMonths[currentMonth] == item) {
                            active = true;
                        } else {
                            active = false;
                        }


                        //console.log(`${item} ${$ExpenseStore.history[year].monthsList[item]}`);

                        list.push({
                            [year]: {
                                collapseId: `collapseId-${uuidv4()}`,
                                name: item,
                                total: $ExpenseStore.history[year].monthsList[item],
                                active: active
                            }
                        });
                    } else {
                        console.log(item, 'doesnt exisits');
                    }
                });
                // console.log($ExpenseStore.history[item].monthsList)

                // list.push({
                //     [item]: {
                //         collapseId: `collapseId-${uuidv4()}`,
                //         name: item,
                //         total: $ExpenseStore.history[item].total,
                //         active: active
                //     }
                // });

                console.log(list);
            });
        }
    }


    return list;
});

export default MonthsList;
